import React from 'react';
import { SkuImport } from '../parse';
import { useTranslation } from 'services/localization';
import { getSkuTableColumns, INVALID_FIELDS_ROW_KEY } from '../importTableUtils';
import BaseImportTable from './BaseImportTable';
import { DataRowObject } from '../utils';

interface Props {
	importData: SkuImport['invalid'];
	headerData: DataRowObject;
}

const InvalidSkusTable = (props: Props) => {
	const { t } = useTranslation();
	const { importData, headerData } = props;

	const rowsData = importData.map((data, index) => ({
		...data.csvFields.data,
		[INVALID_FIELDS_ROW_KEY]: data.csvFields.invalidFields,
		id: index,
	}));

	return <BaseImportTable rows={rowsData} columns={getSkuTableColumns(t, 'invalid', headerData)} />;
};

export default InvalidSkusTable;
